import { useState, useEffect, useContext } from 'react';
import { ActionContext } from 'actions/context';
import { Msg, Button } from 'react-weui';
import Modal from 'components/modal';
import Http from 'services/http2';
import ModalService from 'services/modal';
/**
 * 法人验证页
 */
function VerifyLegalPerson(props) {
  let authCode = props.match.params.authCode;
  const { state, dispatch } = useContext(ActionContext);
  const [companyInfo, setCompanyInfo] = useState({});
  const [code, setCode] = useState('');
  // const [id, setId] = useState('');
  const [complete, setComplete] = useState(false);

  useEffect(() => {
    let postbody = {
      apiPath: '/public/company/getDetail',
      companyCpCode: authCode
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        setCompanyInfo(response.data);
      }
    });
  }, [authCode]);

  // 更新工商资料
  function updateLegalPerson() {
    let postbody = {
      apiPath: '/archives/company/flushBusinessInfo',
      companyCpCode: authCode
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        let obj = Object.assign({}, companyInfo);
        obj.legalPersion = response.data.legalPersion;
        setCompanyInfo(obj);
        ModalService.showTip('工商资料已更新', dispatch);
      }
    });
  }

  function save() {
    let postbody = {
      // idCard: id,
      verificationCode: code,
      authXkNo: authCode,
      apiPath: '/public/company/legalPersonAuth'
    };
    Http.post('/api/cloudCenter', postbody).then(response => {
      if (response.success) {
        setComplete(true);
      } else {
        ModalService.showError(response.errorMsg, dispatch);
      }
    });
  }

  return (
    <div id="vlp">
      {!complete && (
        <div>
          <h3>{companyInfo.companyName}</h3>
          <p>
            您的公司正在进行携客云供应链协同平台的企业注册，请按提示完成验证。
            {/* <span className="red">
              身份证号仅供自动验证使用，平台不保存用户身份证信息。
            </span> */}
          </p>
          <p>
            {/* <span>请输入法人 {companyInfo.legalPersion} 的身份证号码</span> */}
            <span>法人 {companyInfo.legalPersion} </span>
            <a className="update-lp" href="#" onClick={updateLegalPerson}>
              更新工商资料
            </a>
          </p>
          {/* <p>
            <input
              type="text"
              name="id"
              value={id || ''}
              onChange={e => setId(e.target.value)}
            />
          </p> */}
          <p>请输入收到的验证码</p>
          <p>
            <input
              type="number"
              name="code"
              value={code || ''}
              onChange={e => setCode(e.target.value)}
            />
          </p>

          <div className="wrap m-flex-box fixed-bottom">
            <Button
              type="default"
              onClick={save}
              className="m-flex-item u-btn u-btn_primary"
            >
              确认
            </Button>
          </div>
        </div>
      )}

      {complete && (
        <div>
          <h3 class="succ-title green">验证成功</h3>
          <p>企业验证已经成功，企业帐号注册完成！</p>
          <p>
            现在，您可以开始登陆携客云企业帐号，正常处理您的企业与客户的业务。
          </p>
          <p>
            登陆网址：<a href="https://www.xiekeyun.com">www.xiekeyun.com</a>
          </p>
          <p>
            操作视频：
            <a href="https://help.xiekeyun.com/">help.xiekeyun.com/</a>
          </p>
        </div>
      )}
      <Modal></Modal>
    </div>
  );
}

export default VerifyLegalPerson;
